import {
  calendarDateFromStorage,
  calendarDateInTimeZone,
} from './calendar-date'

/** Match personal display filters without changing a record's accounting date. */
export function timeEntryCalendarDay(
  entry: {
    entryType?: string | null
    entryDate?: Date | string | null
    startTime?: Date | string | null
  },
  timezone: string,
  basis: 'display' | 'recorded' = 'display',
): string {
  if (basis === 'display' && entry.entryType === 'TIMER' && entry.startTime) {
    const start = new Date(entry.startTime)
    if (Number.isFinite(start.getTime()))
      return calendarDateInTimeZone(start, timezone)
  }
  return calendarDateFromStorage(entry.entryDate)
}
